let accessToken = null;

export const setAccessToken = (token) => {
  if (typeof token !== "string" || !token.trim()) return;

  if (accessToken === token) return; 
  accessToken = token;
  sessionStorage.setItem("access_token", token);
};

export const getAccessToken = () => {
  if (accessToken) return accessToken;

  const stored = sessionStorage.getItem("access_token");
  if (stored) accessToken = stored;
  return stored;
};
